import { render } from "./IconSidebarArrow.vue?vue&type=template&id=46f65301"
import script from "./IconSidebarArrow.vue?vue&type=script&lang=js"
export * from "./IconSidebarArrow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__